// © Microsoft Corporation. All rights reserved.

import { getExternalURL } from "./urlHelper";

// © Microsoft Corporation. All rights reserved.
export function isValidURL(pageURL, contentURL, whitelist, blacklist) {
    if (!pageURL || (!whitelist && !blacklist) || pageURL.match("bypasslist=true")) {
        return true;
    }

    const considerURL = pageURL.match("/community/embed/") && contentURL && getExternalURL(contentURL) || pageURL;
    if (!considerURL) {
        return true;
    }

    // If whitelists exist at least 1 whitelist condition should be satisfied
    if (whitelist) {
        const whitelistTest = whitelist.split(",").map(x => {
            try {
                return new RegExp(x, "g");
            } catch (e) {
                return x;
            }
        });

        const testPass = whitelistTest.find(x => considerURL.match(x));
        if (!testPass) {
            return false;
        }
    }

    // If blacklists exist none of the blacklist conditions should be satisfied
    if (blacklist) {
        const blacklistTest = blacklist.split(",").map(x => {
            try {
                return new RegExp(x, "g");
            } catch (e) {
                return x;
            }
        });
        const testPass = blacklistTest.find(x => considerURL.match(x));
        if (testPass) {
            return false;
        }
    }
    return true;
}